import React, { Component } from "react";
import TextInput from "../TextInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash,
  faEdit,
  faWindowClose,
  faFolder,
  faFile,
  faClipboard,
  faExternalLinkAlt,
} from "@fortawesome/free-solid-svg-icons";

/** Remove the trailing forward slash from BASE_URL **/
const BASE_URL = process.env.BASE_URL.slice(0, -1);

/**
 * Context menu to edit or delete. an item.
 * Only render if props.contextMenuItemId is not null.
 *
 * <ContextMenu itemName={}
 *    itemType={}
 *    itemId={}
 *    handleEdit={}
 *    handleDelete={}
 *    handleCancel={}
 *    canManage={}
 *    url={}
 * />
 **/
const ContextMenu = (props) => {
  const { itemType, itemId, itemName, canManage, url } = props;
  /**
   * for FILE context menu, renders this input with
   * a stable link to the file url, so that it can
   * be copied (manually or programmatically).
   **/
  const clipBoardInput =
    url != null ? (
      <div
        style={{
          position: "absolute",
          display: "block",
          left: "0",
          right: "0",
          marginLeft: "auto",
          marginRight: "auto",
          textAlign: "center",
          top: "5vh",
          height: "5vh",
        }}
      >
        {/** Contains the upload link **/}
        <input
          id="fileUrl"
          type="text"
          className="readonly-modal-overlay-input"
          value={`${BASE_URL}${url}`}
          readOnly
          style={{
            outlineColor: "transparent",
            border: "none",
            background: "transparent",
            color: "white",
            fontSize: "1.5em",
            textAlign: "center",
            width: "70vw",
          }}
        />
      </div>
    ) : (
      ""
    );

  /** Renders COPY URL option if context menu is for a file **/
  const copyUrlBtn =
    url != null ? (
      <button
        className="btn btn-light inner-buffer"
        style={{ fontSize: "1.5rem" }}
        onClick={copyUrl}
      >
        <span id="copyLinkSpan" className="mr-2">
          Copy Stable Link
        </span>
        <FontAwesomeIcon icon={faClipboard} size="lg" />
      </button>
    ) : (
      ""
    );

  const openUrlNewTabBtn =
    url != null ? (
      <a
        href={url}
        target="_blank"
        className="btn btn-light inner-buffer"
        style={{ fontSize: "1.5rem" }}
      >
        <span className="mr-2">Open File In New Tab</span>
        <FontAwesomeIcon icon={faExternalLinkAlt} size="lg" />
      </a>
    ) : (
      ""
    );

  /** Render RENAME option if user has permission to rename files **/
  const renameBtn = canManage ? (
    <button
      className="btn btn-light inner-buffer"
      style={{ fontSize: "1.5rem" }}
      onClick={() => {
        props.handleEdit(itemType, itemId);
      }}
    >
      <span className="mr-2">Rename</span>
      <FontAwesomeIcon icon={faEdit} size="lg" />
    </button>
  ) : (
    ""
  );

  /** Render DELETE option if user has permission to delete files **/
  const deleteBtn = canManage ? (
    <button
      className="btn btn-light inner-buffer d-flex justify-content-center"
      style={{ fontSize: "1.5rem" }}
      onClick={() => {
        props.handleDelete(itemType, itemId);
      }}
    >
      <span className="mr-2">Delete</span>
      <FontAwesomeIcon icon={faTrash} size="lg" />
    </button>
  ) : (
    ""
  );

  return itemId != null ? (
    <div>
      {/** Background Overlay Div **/}
      <div
        className="modal-overlay"
        style={{
          justifyContent: "center",
          alignItems: "center",
          position: "absolute",
          top: "0",
          bottom: "0",
          left: "0",
          right: "0",
          backgroundColor: "rgba(0, 0, 0, .5)",
          opacity: ".6",
        }}
        onClick={() => {
          props.handleCancel(null, null, null);
        }}
      ></div>
      {clipBoardInput}
      {/** Context Menu Options **/}
      <div
        className="w-50 inner-buffer modal"
        role="dialog"
        style={{ display: "block", left: "25%", top: "10%", height: "auto" }}
      >
        <div className="modal-content inner-buffer btn-group-vertical">
          <div className="d-flex justify-content-center w-100">
            <h2>
              <span className="mr-3 text-muted">{itemName}</span>
              <FontAwesomeIcon
                icon={itemType == "folder" ? faFolder : faFile}
                size="lg"
                color="lightgrey"
              />
            </h2>
          </div>
          {copyUrlBtn}
          {openUrlNewTabBtn}
          {renameBtn}
          {deleteBtn}
          <button
            className="btn btn-light inner-buffer d-flex justify-content-center"
            style={{ fontSize: "1.5rem" }}
            onClick={() => {
              props.handleCancel(null, null, null);
            }}
          >
            <span className="mr-2">Cancel</span>
            <FontAwesomeIcon icon={faWindowClose} size="lg" />
          </button>
        </div>
      </div>
    </div>
  ) : (
    ""
  );
};

/**
 * Programmatically copy the stable file link,
 * when menu is for a file.
 **/
const copyUrl = () => {
  const urlElem = document.getElementById("fileUrl");
  const copyLinkSpan = document.getElementById("copyLinkSpan");
  /* Select the text field */
  urlElem.select();
  urlElem.setSelectionRange(0, 99999); /* For mobile devices */
  /* Copy the text inside the text field */
  document.execCommand("copy");
  /**Update the text of the copy link**/
  copyLinkSpan.innerText = "Copied Link";
};

export default ContextMenu;
